import React, { useEffect, useState } from "react";

import Router from "./router";
import Header from "../components/Header";
import { useAuth } from '../context/auth';
import { useTheme } from '../context/theme';
import AsideBar from '../components/AsideBar';
import Appearance from '../services/Appearance';

function Main(props) {

  const { isConnected } = useAuth()
  const { setBrandColor } = useTheme()
  const [open, setOpen] = useState(false)

  // Cor do menu salva em Configurações > Menu (igual para todos). Se a API falhar, fica a última cor deste navegador
  useEffect(() => {
    if (!isConnected) return
    Appearance.find()
      .then(({ data }) => setBrandColor(data.menu_color))
      .catch(() => { })
  }, [isConnected, setBrandColor])

  return (
    <div style={{ backgroundColor: 'var(--app-page-bg)', minHeight: '100vh' }}>
      {isConnected === true ?
        <>
          <Header
            open={open}
            setOpen={setOpen}
          />
          <AsideBar
            open={open}
            setOpen={setOpen}
          >
            <div style={{ marginTop: 60 }}>
              <Router />
            </div>
          </AsideBar>
        </>
        : <Router />
      }
      {/* <Container fluid> */}
      {/* </Container> */}
    </div >
  );
}

export default Main;
